import React, { useState, useRef } from 'react'
import { Button, Dropdown, PickerView, List, InfiniteScroll, SearchBar } from 'antd-mobile'
// import shopArea from "static/images/shopArea.svg";
// import "static/css/shop.css";

// 无限滚动列表
export function InfiniteScrollList(props) {
  const { data, pageInfo, address, optionData,
    hasMore, loadMore, searchName, handleSelectChange,
    handleSearch, placeholder, renderItem } = props
  const ref = useRef()
  const [pickerAddress, setPickerAddress] = useState(address)
  const options = optionData.map(item => (
    { label: item.FNAME, value: item.ID }))
  const { pageIndex, pageSize } = pageInfo
  const params = {
    address: address || '',//地市
    name: searchName || '',//搜索名称
    pageIndex: pageIndex,//页码
    pageSize: pageSize,//每页大小
  };

  //点击确认按钮关闭选择框
  function handleDropdownClick() {
    handleSelectChange(pickerAddress)
    ref.current?.close()
  }

  return (
    <>
      <Dropdown ref={ref} className='text'>
        <Dropdown.Item key='sorter' title={address ? address : '请选择地市'} >
          <div className='optionArea'>
            <PickerView
              columns={[options]}
              onChange={(val, extend) => {
                setPickerAddress(extend.items[0].label)
                //setAddArea(extend.items[0].label)
              }}
            />
            <Button
              color='primary'
              size='mini'
              className='optionAreaBut'
              onClick={handleDropdownClick}
            >
              确认
            </Button>
          </div>
        </Dropdown.Item>
        <div className='selectArea'>
          <SearchBar
            style={{
              '--border-radius': '100px',
              '--background': '#F2F3F7'
            }}
            placeholder={placeholder}
            onSearch={value => handleSearch(value)}
            onClear={() => { handleSearch('') }}
          //onChange={value => value === '' && setSearchName('')}
          />
        </div>
      </Dropdown>
      <List className='shopList'>
        {data !== [] && data.map(item => (renderItem(item)))}
      </List>
      <InfiniteScroll loadMore={() => loadMore(params)} hasMore={hasMore} />
    </>
  )
}